<mat-label>Sort By:</mat-label>
<mat-form-field id="pendo-skills-sortby" appearance="outline" class="accessible-dropdown">
  <mat-select panelClass="accessible-selector" disableOptionCentering
    [value]="selectedOption"
    (selectionChange)="updateSort.emit($event.value)">
    <mat-option [value]="option" *ngFor="let option of options">{{option}}</mat-option>
  </mat-select>
</mat-form-field>
